import MinusIcon from '@assets/icons/minus.svg?react'
import PlusIcon from '@assets/icons/plus.svg?react'
import clsx from 'clsx'
import { useEffect, useState } from 'react'

import s from './Counter.module.scss'
import type { CounterProps } from './Counter.props'

export function Counter({ min, max, initValue, text, icon, type = 'center', onChange }: CounterProps) {
  const [value, setValue] = useState<number>(min)

  const handleIncrement = () => {
    if (value < max) {
      setValue(value + 1)
      onChange(value + 1)
    }
  }

  const handleDecrement = () => {
    if (value > min) {
      setValue(value - 1)
      onChange(value - 1)
    }
  }

  useEffect(() => {
    if (value > max) {
      setValue(max)
      onChange(max)
    } else if (value < min) {
      setValue(min)
      onChange(min)
    }
  }, [min, max])

  useEffect(() => {
    if (initValue === undefined) return

    setValue(initValue)
    onChange(initValue)
  }, [initValue])

  return (
    <div className={clsx(s.counter, { [s.inline]: type === 'reversed' })}>
      <button
        className={s.btn}
        onClick={handleDecrement}
      >
        <MinusIcon />
      </button>

      {!!icon && (
        <div className={s.iconWrapper}>
          <img
            src={icon}
            alt="Icon"
            width={24}
            height={24}
            className={s.icon}
          />
        </div>
      )}

      <div className={s.value}>{value}</div>
      {!!text && <div className={s.text}>{text}</div>}

      <button
        className={s.btn}
        onClick={handleIncrement}
      >
        <PlusIcon />
      </button>
    </div>
  )
}
